let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lNQPq")).then(() => parcelRequire('jYoMg'));